export default __webpack_public_path__ + "static/media/funghi.8178cc9c.mp3";